// NGRX
import { Store, select } from '@ngrx/store';
// CRUD
import { BaseDataSource, QueryResultsModel } from '../../_base/crud';
// State
import { AppState } from '../../reducers';
import {
  selectDrugsInStore,
  selectDrugsPageLoading,
  selectDrugsShowInitWaitingMessage,
} from '../_selectors/drug.selectors';

export class DrugsDataSource extends BaseDataSource {
  constructor(private store: Store<AppState>) {
    super();

    this.loading$ = this.store.pipe(select(selectDrugsPageLoading));

    this.isPreloadTextViewed$ = this.store.pipe(select(selectDrugsShowInitWaitingMessage));

    this.store.pipe(select(selectDrugsInStore)).subscribe((response: QueryResultsModel) => {
      this.paginatorTotalSubject.next(response.totalCount);
      this.entitySubject.next(response.items);
    });
  }
}
